import type { ReactNode } from "react";
import { cn } from "../lib/cn.js";

/**
 * 错误/警告 banner — **amber 调，非红色**（per CLAUDE.md §非 bug 不红色）。
 * 真崩溃用 ErrorBoundary 兜底。
 */
export function ErrorBanner({
  children,
  onDismiss,
  className,
}: {
  children: ReactNode;
  onDismiss?: () => void;
  className?: string;
}): JSX.Element {
  return (
    <div
      role="alert"
      className={cn(
        "flex items-start justify-between gap-3 rounded-md border border-amber-500/30 bg-amber-500/10 px-3 py-2 text-sm text-amber-800",
        className,
      )}
    >
      <div className="flex-1">{children}</div>
      {onDismiss ? (
        <button
          type="button"
          onClick={onDismiss}
          className="shrink-0 text-amber-700 hover:text-amber-900"
          aria-label="关闭"
        >
          ×
        </button>
      ) : null}
    </div>
  );
}

/**
 * Info banner — amber accent，提示性信息。
 * 用于无错误但需要醒目说明（如"飞书后台关 encrypt"）。
 */
export function InfoBanner({
  children,
  className,
}: {
  children: ReactNode;
  className?: string;
}): JSX.Element {
  return (
    <div
      className={cn(
        "rounded-md border border-amber-500/30 bg-amber-500/10 px-3 py-2 text-sm text-amber-800",
        className,
      )}
    >
      {children}
    </div>
  );
}
